import React from 'react'
import { Button } from '@mui/material'
import './index.scss'

import IconLabelButton from '../OldPortalComponents/IconLabelButton'
import { useTranslation } from 'react-i18next'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { useQuizImport } from '@/hooks/useQuizImport'
import DocumentUploadSection from '@/components/Quizzes/DocumentUploadSection'
import QuizImportInstructions from '@/components/Quizzes/QuizImportInstructions'

const ImportQuiz: React.FC = () => {
  const { t } = useTranslation('translation')
  const {
    documents,
    isFileUploading,
    selectedUploadType,
    handleFileSelection,
    handleFileRemove,
    handleRadioChange,
    handleImport,
  } = useQuizImport({ mode: 'import-quiz' })

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader
        title={t('Import Quiz')}
        subTitle={t('Upload a document with questions to create a new quiz')}
        slot={{
          action: (
            <Button
              variant="contained"
              size="medium"
              disabled={isFileUploading}
              onClick={handleImport}
            >
              {t('Import Quiz')}
            </Button>
          ),
        }}
      />

      <div className="upload-document-page-container add-faq-container">
        <div className="page-content-container">
          <div className="custom-control custom-radio mb-0">
            <input
              id="customtemplates-radio"
              type="radio"
              value="customtemplates"
              className="custom-control-input faq-option-radio"
              name="faq-upload-option"
              checked={selectedUploadType === 'customtemplates'}
              onChange={e => handleRadioChange(e.target.value)}
            />
            <label
              className="custom-control-label font-weight-bold"
              htmlFor="customtemplates-radio"
            >
              {t(
                'I want to upload a document with a list of questions and answers',
              )}
            </label>
          </div>
          <div className="radio-label-wrapper pl-4">
            {t(
              'Choose this if you have a list of quiz questions and answers ready in any format. The questions will be extracted from the uploaded document. You can edit them in the next screen.',
            )}
          </div>

          {selectedUploadType === 'customtemplates' && (
            <React.Fragment>
              <QuizImportInstructions />

              <DocumentUploadSection
                documents={documents}
                onFilesSelected={files =>
                  handleFileSelection(files, 'customtemplates')
                }
                onFileRemove={handleFileRemove}
                isUploading={isFileUploading}
                supportedTypes=".docx, .txt, .pdf"
              />
            </React.Fragment>
          )}
        </div>

        <div className="page-content-container mt-4">
          <div className="custom-control custom-radio mb-0">
            <input
              id="nfaquiztemplates-radio"
              type="radio"
              value="nfaquiztemplates"
              className="custom-control-input faq-option-radio"
              name="faq-upload-option"
              checked={selectedUploadType === 'nfaquiztemplates'}
              onChange={e => handleRadioChange(e.target.value)}
            />
            <label
              className="custom-control-label font-weight-bold"
              htmlFor="nfaquiztemplates-radio"
            >
              {t(
                'I want to use Noodle Factory template to upload quiz questions',
              )}
            </label>
          </div>
          <div className="radio-label-wrapper pl-4">
            {t(
              'Choose this if you have a formatted list of quiz questions and answers in a document. You can download the',
            )}{' '}
            <IconLabelButton
              showIcon
              iconClass="icon-download"
              buttonLabel="sample quiz template"
              useDownload
              fileSrc="https://oldportal.staging.noodlefactory.ai/static/media/sample-quiz-template.79b29ea8.docx"
            />
            {t(
              'and edit it before uploading. Note that the document must be in the given format.',
            )}
          </div>

          {selectedUploadType === 'nfaquiztemplates' && (
            <DocumentUploadSection
              documents={documents}
              onFilesSelected={files =>
                handleFileSelection(files, 'nfaquiztemplates')
              }
              onFileRemove={handleFileRemove}
              isUploading={isFileUploading}
              supportedTypes=".docx, .txt"
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default ImportQuiz
